function retrieveFinalPaymentDays(companyId) {
    return window.tenantAxios.get(`/company/${companyId}/final-payment-days`);
}

function updateFinalPaymentDays(companyId, finalPaymentDays) {
    return window.tenantAxios.patch(`/company/${companyId}/final-payment-days`, finalPaymentDays);
}

export default {
    retrieveFinalPaymentDays,
    updateFinalPaymentDays,
};
